import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Toggle from 'material-ui/Toggle';
import getTheme from '../MuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

var LLToggle = /*#__PURE__*/function (_Component) {
  _inherits(LLToggle, _Component);

  var _super = _createSuper(LLToggle);

  function LLToggle() {
    var _this;

    _classCallCheck(this, LLToggle);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "checkboxChecked", function (event, isChecked) {
      if (_this.props.onToggle) {
        _this.props.onToggle(isChecked);
      }
    });

    return _this;
  }

  _createClass(LLToggle, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Toggle, _extends({}, this.props, {
        label: this.props.label,
        style: this.props.style,
        onToggle: this.checkboxChecked,
        disabled: this.props.disabled,
        className: this.props.className,
        labelStyle: {
          fontFamily: 'oswald',
          textTransform: 'uppercase'
        }
      }));
    }
  }]);

  return LLToggle;
}(Component);

_defineProperty(LLToggle, "propTypes", {
  label: PropTypes.node,
  style: PropTypes.object,
  toggled: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  input: PropTypes.object
});

_defineProperty(LLToggle, "defaultProps", {
  label: '',
  style: {},
  toggled: false,
  onToggle: null,
  disabled: false,
  className: ''
});

export { LLToggle as default };